export default "__VITE_ASSET__5d825118__"